import { memo, useMemo } from 'react';
import { LOCATIONS, SCRIP_INSTRUMENTS, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { BzChip } from '../../components';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
//Vaibhav Singh: 06-03-24: Pagecalled variable added as we are not showing name of exchange: Start
function WatchlistSymbolColumn({ arrRowData, isScrenners = false, value, pageCalled }) {

    const { holdingsScrips } = useSelector(state => state.holdings);

    const { pathname } = useLocation();
    const isLocationDahsboard = useMemo(() => {
        if (pathname === LOCATIONS.WATCHLIST && isScrenners) {
            return true;
        } else {
            return false;
        }
    }, [pathname, isScrenners]);

    // Ameersha N | BT-95888 Create Watchlist Feature start
    const WatchlistGridPopoverName = ({ arrRowData }) => {
        if (arrRowData?.length > 0) {
            if ((arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
                arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT])) {
                return (<div className={`${isLocationDahsboard ? "font-regular font-size1 color-subtext line-height-1 me-1" : "font-regular font-enlarge color-subtext line-height-1 me-1"}`}>{`${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)} ${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE]} ${arrRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE]} `}</div>);
            } else if (!arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
                !arrRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE]) {
                return (<div className='d-flex align-items-center'>
                    <div className={`${isLocationDahsboard ? "font-regular font-size1 color-subtext line-height-1 me-1" : "font-regular font-enlarge color-subtext line-height-1 me-1"}`}>{arrRowData[WATCHLIST_GRID_INDEX.SERIES]}</div>
                </div>);
            }
            else if (arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE]) {
                return (
                    <div className={`${isLocationDahsboard ? "font-regular font-size1 color-subtext line-height-1 me-1" : "font-regular font-enlarge color-subtext line-height-1 me-1"}`}>{`${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)} ${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT].slice(0, 3)} `}</div>
                );
            }
            else {
                return null;
            }
        } else {
            return null;
        }
    };
    // Ameersha N | BT-95888 Create Watchlist Feature end
    const arrAlerts = useSelector(state => state.alerts.arrAlerts);
    const objAlert = useMemo(() => arrAlerts?.length > 0 && arrAlerts?.find((alert) => alert?.mktIdToken === arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]), [arrRowData, arrAlerts]);
    const location = useLocation();
    return (
        <div className='scrip-wrap'>
            {
                arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0' && arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 && Object?.keys(arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS][0])?.includes('event') &&
                <div className='normal-scrip dontmiss-scrip'></div>
            }
            <div className='d-flex justify-content-start align-items-center'>
                <div className={`${isLocationDahsboard ? "font-medium font-size1 color-text text-uppercase line-height-1 me-2" : "font-medium font-enlarge color-text text-uppercase line-height-1 me-2"}`} >{value}</div>  {/* Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings */}
                {(pageCalled) ? (arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]) ? <div className='chips-wrap'>
                    <BzChip className='exchange-chip me-2'>{arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                </div> : null : <div className='chips-wrap'>
                    <BzChip className='exchange-chip me-2'>{arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                </div>}
                <WatchlistGridPopoverName arrRowData={arrRowData} />
                {
                    arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0' && arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 && Object?.keys(arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS][0])?.includes('event') &&
                    <div className='icon-16 icon-dontmiss icon-yellow me-2'></div>
                }
                {/* Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed totalfreequantity also updated: Start */}
                {holdingsScrips?.length > 0 && holdingsScrips?.some(element => element?.TOTALFREEQUANTITY !== "0" && element?.ISIN === arrRowData[WATCHLIST_GRID_INDEX.ISIN_CODE] && arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES) &&
                    <div className='icon-16 icon-portfolio icon-dark me-2'></div>
                }
                {/* Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed totalfreequantity also updated: End */}

                {/* // Azeem K : 02-09-2025 : BREEZE-10052 Require Segment wise position – Start
                                       LLD Comment :conditional JSX for alert icon added here for applicable scrips*/}
                {objAlert && location?.pathname !== '/recommendations' && <div class="icon-20 icon-alert icon-primary me-1"></div>}
                {/* // Azeem K : 02-09-2025 : BREEZE-10052 Require Segment wise position – End  */}
            </div>

        </div>
    );
}
//Vaibhav Singh: 06-03-24: Pagecalled variable added as we are not showing name of exchange: 
export default memo(WatchlistSymbolColumn);